import { CONSTANTS } from '../config/constants';
// @ts-ignore
import * as sjcl from 'sjcl';

function boot(intercom: any, currentUser: any, retailer: any) {
  const sharedSecret = CONSTANTS.intercomHashSecret;
  const hmac = new sjcl.misc.hmac(sjcl.codec.utf8String.toBits(sharedSecret), sjcl.hash.sha256);
  if (currentUser) {
    const hash = sjcl.codec.hex.fromBits(hmac.encrypt(currentUser.objectId));
    intercom.boot({
      name: currentUser.name,
      email: currentUser.email,
      user_id: currentUser.objectId,
      user_hash: hash,
      created_at: currentUser.createdAt,
      company: {
          id: retailer.objectId,
          name: retailer.name,
          created_at: retailer.createdAt,
      },
      hide_default_launcher: true,
    });
  }
}

export const intercomService = {
  boot,
};
